import {MarketConfigType} from "../../typings";
import {BaseDict} from "../../blocks/EventListPresenter/dict";

export const mapMarketName = (marketConfig : MarketConfigType, dict : BaseDict, sportId: string): string[] => {
    return [dict[`${sportId}_${marketConfig.idLive}`]
        || dict[`${sportId}_${marketConfig.idPreLive}`]
        || dict[marketConfig.idLive]
        || dict[marketConfig.idPreLive]
        || marketConfig.idLive];
}